import React from 'react';

// Simple aria-live region for announcing short status messages
export default function LiveRegion() {
  const [msg, setMsg] = React.useState('');

  React.useEffect(() => {
    const onEvt = (e) => {
      try { setMsg(e.detail?.message || String(e.detail || '')); } catch { setMsg(''); }
      // clear shortly so repeats can be announced
      const t = setTimeout(() => setMsg(''), 3000);
      return () => clearTimeout(t);
    };
    window.addEventListener('app:status', onEvt);
    return () => window.removeEventListener('app:status', onEvt);
  }, []);

  return (
    <div className="sr-only" role="status" aria-live="polite" data-testid="live-region">{msg}</div>
  );
}
